















































































































import Vue, { PropType } from "vue";
import { mapActions, mapMutations } from "vuex";
import Locale from "@/service/Locale/Locale";
import Modal from "./InviteAdministratorModal.vue";

import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import log from "loglevel";

extend("required", required);
extend("max", max);

const ADMINISTRATOR_NAME_MAX_COUNT = 190;

interface InviteAdministratorProps {
  lang: any;
  supportUrl: string;
  licenseName: string;
  volumeLicenseId: string;
}

interface InviteAdministratorData {
  administratorName: string;
  isAgree: boolean;
  inputRule: string;
  isLoading: boolean;
  showModal: boolean;
  isLimit: boolean;
  currentScrollAmount: {
    x: number;
    y: number;
  };
}

export default Vue.extend({
  name: "vc-invite-administrator",
  components: {
    ValidationObserver,
    ValidationProvider,
    "vc-invite-administrator-modal": Modal,
  },
  props: {
    lang: {
      type: Object as PropType<InviteAdministratorProps["lang"]>,
      default: () => {},
    },
    supportUrl: {
      type: String as PropType<InviteAdministratorProps["supportUrl"]>,
      default: "",
    },
    licenseName: {
      type: String as PropType<InviteAdministratorProps["licenseName"]>,
      default: "",
    },
    volumeLicenseId: {
      type: String,
      default: "",
    },
  },
  data(): InviteAdministratorData {
    return {
      administratorName: "",
      isAgree: false,
      inputRule: "required|max:" + ADMINISTRATOR_NAME_MAX_COUNT,
      isLoading: false,
      showModal: false,
      isLimit: false,
      currentScrollAmount: {
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    const locale = Locale.getLocale();
    localize(locale, {
      messages: {},
      fields: {
        administratorNameProvider: {
          required: this.lang.input_error.required,
          max: this.lang.input_error.length.replace(
            ":length",
            ADMINISTRATOR_NAME_MAX_COUNT
          ),
        },
      },
    });

    this.updateVolumeLicensesId(this.volumeLicenseId);

    // 「確認しました」チェックボックス初期化
    window.addEventListener("unload", () => {
      this.isAgree = false;
    });
    // 「確認しました」チェックボックスSafari時リロード
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    });
  },
  methods: {
    ...mapActions("common", ["createErrorNotification"]),
    ...mapActions("inviteAdministrator", ["postAdministratorInvitationUrl"]),
    ...mapMutations("inviteAdministrator", ["updateVolumeLicensesId"]),
    openModal() {
      this.showModal = true;

      // モーダルを開いている時は背景がスクロールされないよう現在スクロール位置を保持する
      this.currentScrollAmount = {
        x: window.scrollX || window.pageXOffset,
        y: window.scrollY || window.pageYOffset,
      };
      document.body.classList.add("fixedPosition");
      document.body.style.top = (-this.currentScrollAmount.y).toString() + "px";
      document.body.style.left =
        (-this.currentScrollAmount.x).toString() + "px";
      // position:fixedとするとiOS15で下部に空白が生まれるため全体の高さを指定する
      document.documentElement.style.height = "100vh";
    },
    closeModal() {
      this.showModal = false;

      // モーダルを閉じた時は表示処理をスクロール位置に戻す
      document.body.classList.remove("fixedPosition");
      window.scrollTo(this.currentScrollAmount.x, this.currentScrollAmount.y);
      document.documentElement.style.height = "";
    },
    async onClickPostAdministratorInvitationUrl() {
      this.isLoading = true;

      try {
        await this.postAdministratorInvitationUrl({
          administrator_name: this.administratorName,
        });
        this.openModal();
      } catch (error) {
        if (error.status === 409) {
          this.isLimit = true;
        } else {
          this.createErrorNotification({
            label: this.lang.generate_url_error,
            style: "is-danger",
            linkLabel: this.lang.link_in_description,
            link: this.supportUrl,
          });
        }
        log.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
